import {
    AdminProductCategoryList_adminProductCategories,
} from '@api/graphql/types';

export enum ProductCategoryActionType {
    updateProductCategoryList = '@productCategories/updateProductCategoryList',
}

interface ActionType {
    type: ProductCategoryActionType;
}

export interface UpdateProductCategoryListType extends ActionType {
    productCategories: Array<AdminProductCategoryList_adminProductCategories | null>;
}


export function updateProductCategoryList(productCategories: Array<AdminProductCategoryList_adminProductCategories | null>): UpdateProductCategoryListType {
    return {
        type: ProductCategoryActionType.updateProductCategoryList,
        productCategories,
    };
}

export type ProductCategoryAction = UpdateProductCategoryListType;



// WEBPACK FOOTER //
// ./src/actions/productCategoryActions.ts